import { getMeta } from 'app/core/http';
import { Exception } from 'app/core/status';

/**
 * To get the survey meta.
 * If on `preview` mode, won't get the meta.
 */
export async function initialMeta(surveyHash: string, preview: boolean) {
  try {
    if (preview) {
      return;
    }

    return await getMeta(surveyHash);
  } catch (error) {
    throw new Exception('NOT_FOUND');
  }
}
